import { HiOutlineInformationCircle } from "react-icons/hi2";

const InfoIcon = ({ className = "w-4 h-4 text-blue-500" }) => (
  <HiOutlineInformationCircle className={className} />
);

export default InfoIcon;
